import { lazy } from "react";

export const lazyWithReload = (importFn) => {
  return lazy(() =>
    importFn().catch((error) => {
      console.error("Lazy loading failed, reloading page:", error);
        window.location.reload();
      return new Promise(() => {});
    })
  );
};
